<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <ng-content></ng-content>
    @if (showButtons()) {
    <div class="form-actions">
        <button type="submit" class="btn btn-primary">Submit</button>
        <button type="button"
                class="btn btn-secondary"
                (click)="resetForm()">
            Reset
        </button>
    </div>
    }
</form>
